const works = [
  {
    company: "EMOV Public Company",
    positionKey: "emov.position",
    tareasKey: "emov.tasks",
    inicio: "10/04/2023",
    fin: "31/01/2024",
    location: "Cuenca, Azuay"
  },
  {
    company: "LibelulaSoft Ltda",
    positionKey: "libelula1.position",
    tareasKey: "libelula1.tasks",
    inicio: "01/2022",
    fin: "01/2023",
    location: "Cuenca, Azuay"
  },
  {
    company: "Webdit",
    positionKey: "webdit.position",
    tareasKey: "webdit.tasks",
    inicio: "05/2020",
    fin: "05/2021",
    location: "Cuenca, Azuay"
  },
  {
    company: "LibelulaSoft Ltda",
    positionKey: "libelula2.position",
    tareasKey: "libelula2.tasks",
    inicio: "01/2019",
    fin: "02/2019",
    location: "Cuenca, Azuay"
  }
];

export { works };
